import { render, staticRenderFns } from "./OrderTypeSelect.vue?vue&type=template&id=d47e48fe"
import script from "./OrderTypeSelect.vue?vue&type=script&lang=ts"
export * from "./OrderTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports